var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 121,
    viewBox: "0 0 230 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M229.396 114.913C229.396 84.5728 217.344 55.4756 195.891 34.0221C174.437 12.5686 145.34 0.516116 115 0.516113C84.6602 0.516111 55.563 12.5686 34.1095 34.0221C12.656 55.4756 0.60352 84.5727 0.603516 114.913L115 114.913H229.396Z",
    fill: "url(#paint0_linear_807_3467)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M212.323 112.426C212.323 86.6142 202.07 61.8598 183.818 43.6082C165.567 25.3567 140.812 15.103 115.001 15.103C89.189 15.103 64.4345 25.3567 46.1829 43.6082C27.9314 61.8598 17.6777 86.6142 17.6777 112.426L115.001 112.426H212.323Z",
    fill: "url(#paint1_linear_807_3467)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M194.458 108.61C194.458 87.5366 186.087 67.3267 171.186 52.4259C156.285 37.525 136.076 29.1538 115.003 29.1538C93.9297 29.1538 73.7198 37.525 58.8189 52.4259C43.9181 67.3267 35.5469 87.5366 35.5469 108.61L115.003 108.61H194.458Z",
    fill: "url(#paint2_linear_807_3467)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_807_3467)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_807_3467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_807_3467",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.177 74.3224V102.512C141.177 104.114 140.54 105.651 139.407 106.783C138.274 107.916 136.738 108.553 135.136 108.553H94.8649C93.2628 108.553 91.7263 107.916 90.5935 106.783C89.4606 105.651 88.8242 104.114 88.8242 102.512V74.3224M141.177 74.3224C141.177 72.7203 140.54 71.1838 139.407 70.051C138.274 68.9182 136.738 68.2817 135.136 68.2817H94.8649C93.2628 68.2817 91.7263 68.9182 90.5935 70.051C89.4606 71.1838 88.8242 72.7203 88.8242 74.3224M141.177 74.3224V74.9748C141.177 76.0061 140.913 77.0203 140.41 77.9207C139.907 78.8212 139.182 79.5779 138.304 80.1187L118.168 92.5088C117.216 93.0955 116.119 93.4061 115 93.4061C113.882 93.4061 112.785 93.0955 111.832 92.5088L91.6969 80.1214C90.8188 79.5805 90.0937 78.8238 89.5909 77.9234C89.088 77.023 88.8241 76.0088 88.8242 74.9775V74.3224"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 74.3224V102.512C141.177 104.114 140.54 105.651 139.407 106.783C138.274 107.916 136.738 108.553 135.136 108.553H94.8649C93.2628 108.553 91.7263 107.916 90.5935 106.783C89.4606 105.651 88.8242 104.114 88.8242 102.512V74.3224M141.177 74.3224C141.177 72.7203 140.54 71.1838 139.407 70.051C138.274 68.9182 136.738 68.2817 135.136 68.2817H94.8649C93.2628 68.2817 91.7263 68.9182 90.5935 70.051C89.4606 71.1838 88.8242 72.7203 88.8242 74.3224M141.177 74.3224V74.9748C141.177 76.0061 140.913 77.0203 140.41 77.9207C139.907 78.8212 139.182 79.5779 138.304 80.1187L118.168 92.5088C117.216 93.0955 116.119 93.4061 115 93.4061C113.882 93.4061 112.785 93.0955 111.832 92.5088L91.6969 80.1214C90.8188 79.5805 90.0937 78.8238 89.5909 77.9234C89.088 77.023 88.8241 76.0088 88.8242 74.9775V74.3224",
    fill: "url(#paint3_linear_807_3467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8242 102.512H87.7776H88.8242ZM88.8242 74.3224H87.7776H88.8242ZM94.8649 68.2817V67.2351V68.2817ZM141.177 74.9748H140.13V74.9749L141.177 74.9748ZM138.304 80.1187L138.852 81.0101L138.853 81.0098L138.304 80.1187ZM118.168 92.5088L117.62 91.6174L117.619 91.6176L118.168 92.5088ZM115 93.4061V94.4527V93.4061ZM111.832 92.5088L112.381 91.6176L112.381 91.6174L111.832 92.5088ZM91.6969 80.1214L91.148 81.0125L91.1485 81.0128L91.6969 80.1214ZM88.8242 74.9775L89.8708 74.9776V74.9775H88.8242ZM140.13 74.3224V102.512H142.223V74.3224H140.13ZM140.13 102.512C140.13 103.837 139.604 105.107 138.667 106.043L140.147 107.524C141.476 106.194 142.223 104.392 142.223 102.512H140.13ZM138.667 106.043C137.731 106.98 136.46 107.506 135.136 107.506V109.599C137.016 109.599 138.818 108.853 140.147 107.524L138.667 106.043ZM135.136 107.506H94.8649V109.599H135.136V107.506ZM94.8649 107.506C93.5404 107.506 92.2701 106.98 91.3335 106.043L89.8534 107.524C91.1825 108.853 92.9852 109.599 94.8649 109.599V107.506ZM91.3335 106.043C90.397 105.107 89.8708 103.837 89.8708 102.512H87.7776C87.7776 104.392 88.5243 106.194 89.8534 107.524L91.3335 106.043ZM89.8708 102.512V74.3224H87.7776V102.512H89.8708ZM142.223 74.3224C142.223 72.4427 141.476 70.6401 140.147 69.3109L138.667 70.7911C139.604 71.7276 140.13 72.9979 140.13 74.3224H142.223ZM140.147 69.3109C138.818 67.9818 137.016 67.2351 135.136 67.2351V69.3283C136.46 69.3283 137.731 69.8545 138.667 70.7911L140.147 69.3109ZM135.136 67.2351H94.8649V69.3283H135.136V67.2351ZM94.8649 67.2351C92.9852 67.2351 91.1825 67.9818 89.8534 69.3109L91.3335 70.7911C92.2701 69.8545 93.5404 69.3283 94.8649 69.3283V67.2351ZM89.8534 69.3109C88.5243 70.6401 87.7776 72.4427 87.7776 74.3224H89.8708C89.8708 72.9979 90.397 71.7276 91.3335 70.7911L89.8534 69.3109ZM140.13 74.3224V74.9748H142.223V74.3224H140.13ZM140.13 74.9749C140.13 75.8275 139.912 76.666 139.496 77.4104L141.324 78.431C141.914 77.3746 142.223 76.1847 142.223 74.9747L140.13 74.9749ZM139.496 77.4104C139.08 78.1549 138.481 78.7804 137.755 79.2276L138.853 81.0098C139.883 80.3753 140.734 79.4875 141.324 78.431L139.496 77.4104ZM137.755 79.2274L117.62 91.6174L118.717 93.4001L138.852 81.0101L137.755 79.2274ZM117.619 91.6176C116.832 92.1027 115.925 92.3595 115 92.3595V94.4527C116.313 94.4527 117.6 94.0882 118.717 93.3999L117.619 91.6176ZM115 92.3595C114.075 92.3595 113.169 92.1027 112.381 91.6176L111.283 93.3999C112.401 94.0882 113.688 94.4527 115 94.4527V92.3595ZM112.381 91.6174L92.2453 79.23L91.1485 81.0128L111.284 93.4002L112.381 91.6174ZM92.2458 79.2303C91.5198 78.7831 90.9204 78.1575 90.5047 77.4131L88.6771 78.4337C89.2671 79.4901 90.1177 80.3779 91.148 81.0125L92.2458 79.2303ZM90.5047 77.4131C90.0889 76.6687 89.8707 75.8302 89.8708 74.9776L87.7776 74.9773C87.7775 76.1874 88.0872 77.3773 88.6771 78.4337L90.5047 77.4131ZM89.8708 74.9775V74.3224H87.7776V74.9775H89.8708Z",
    fill: "url(#paint4_linear_807_3467)",
    mask: "url(#path-4-inside-1_807_3467)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_807_3467",
    x: 76.265,
    y: 59.9089,
    width: 77.4699,
    height: 65.3894,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.1864
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.27959
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_807_3467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_807_3467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_807_3467",
    x1: 115,
    y1: 0.516113,
    x2: 115,
    y2: 111.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7974F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_807_3467",
    x1: 115.001,
    y1: 15.103,
    x2: 115.001,
    y2: 109.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7974F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_807_3467",
    x1: 115.003,
    y1: 29.1538,
    x2: 115.003,
    y2: 106.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7974F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_807_3467",
    x1: 115,
    y1: 68.2817,
    x2: 115,
    y2: 108.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_807_3467",
    x1: 115,
    y1: 68.2817,
    x2: 115,
    y2: 108.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974F",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_807_3467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.4336,
    height: 64.4336,
    fill: "white",
    transform: "translate(82.7832 56.2007)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6be911e117d342d80c5c975cddb363a3.svg";
export { ForwardRef as ReactComponent };